var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaMorocco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_20465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V45H0V0Z",
    fill: "#C1272D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9996 15.0435L28.3222 20.2078H22.9094L27.2901 23.3852L25.6199 28.5272L29.9996 25.3505L34.3794 28.5272L32.7092 23.3852L37.0898 20.2078H31.6771L29.9996 15.0435ZM32.0334 21.3047H33.7094L32.353 22.2885L32.0334 21.3047ZM31.4196 22.9655L30.8801 21.3047H29.1192L28.5797 22.9655L29.9996 23.9955L31.4196 22.9655ZM31.7758 24.0622L32.2949 25.6603L30.9337 24.673L31.7758 24.0622ZM29.0655 24.673L27.7044 25.6603L28.2235 24.0622L29.0655 24.673ZM27.6463 22.2885L26.2898 21.3047H27.9659L27.6463 22.2885ZM29.4754 20.2078H30.5238L29.9996 18.594L29.4754 20.2078Z",
    fill: "#006233"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_20465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaMorocco);
export default __webpack_public_path__ + "static/media/ma Morocco.cb60bfd8a4f849b9440d27881bae343b.svg";
export { ForwardRef as ReactComponent };